<template>
  <div>
    <div class="c-template-table table-responsive">
      <table class="table table-bordered table-hover">
        <thead>
          <tr>
            <th class="th-check">#</th>
            <th>Thời gian</th>
            <th class="text-center" style="min-width: 400px">Loại sự kiện</th>
            <th>Ghi chú</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(event, index) in formattedEvents" :key="event._id">
            <td class="th-check">
              {{ itemCount - (index + (filterFormModel.page - 1) * filterFormModel.pageSize) }}
            </td>
            <td>
              <p style="white-space: nowrap">
                <b>Lúc: </b>
                {{ event.time | moment('DD/MM/YYYY HH:mm') }}
              </p>
              <p style="white-space: nowrap">
                <b>Bởi: </b>
                <button-link-user v-if="event.user" :user="event.user" />
                <span v-else>Hệ thống</span>
              </p>
            </td>
            <td class="text-center">
              <p v-if="event.displayedType" :class="event.displayedType.className">{{ event.displayedType.text }}</p>
              <p>
                <benh-nhan-detail
                  v-if="event.type == null || event.type == 'care'"
                  :benh-nhan="benhNhan"
                  :history="event"
                />
              </p>
            </td>
            <td>
              {{ event.note || 'Không có ghi chú' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="c-paging" v-if="itemCount > filterFormModel.pageSize">
      <b-pagination
        size="sm"
        class="pagination pagination-sm justify-content-center"
        v-model="filterFormModel.page"
        :total-rows="itemCount"
        :per-page="filterFormModel.pageSize"
        @input="load"
      >
      </b-pagination>
    </div>
  </div>
</template>

<script>
import list from '../../mixins/List';
import BenhNhanDetail from './BenhNhanDetail.vue';
import ButtonLinkUser from './components/ButtonLinkUser';

const TYPE_TO_BADGE_TEXT = Object.freeze({
  care: 'Gọi chăm sóc',
  requestChangeNc: 'Đề nghị chuyển nhóm NC',
  requestChangeNcAccept: 'Duyệt đề nghị chuyển nhóm NC',
  requestChangeNcDeny: 'Từ chối đề nghị chuyển nhóm NC',
  fault: 'Báo lỗi',
  removeFault: 'Gỡ lỗi',
  stopFollow: 'Ngừng theo dõi',
  stopFollowRequest: 'Đề xuất ngừng theo dõi',
  stopFollowRequestApprove: 'Chấp thuận đề xuất ngừng theo dõi',
  stopFollowRequestReject: 'Từ chối đề xuất ngừng theo dõi',
  reFollow: 'Theo dõi lại',
  requestEmergency: 'Đề nghị cấp cứu',
  requestEmergencyCancel: 'Huỷ đề nghị cấp cứu',
  requestEmergencyApprove: 'Tiếp nhận đề nghị cấp cứu',
  requestEmergencyReject: 'Từ chối đề nghị cấp cứu',
  requestCommunityCare: 'Đề nghị chăm sóc cộng đồng',
  requestCommunityCareCancel: 'Huỷ đề nghị chăm sóc cộng đồng',
  communityCare: 'Tiếp nhận đề nghị chăm sóc cộng đồng',
  create: 'Tạo mới bệnh nhân',
  update: 'Cập nhật thông tin bệnh nhân',
});

const UNFOLLOW_TO_BADGE_TEXT = Object.freeze({
  nhapvien: 'Đã được nhập viện điều trị',
  khoibenh: 'Đã được công bố khỏi bệnh & có chứng nhận',
  tuvong: 'Tử vong',
  bn_tu_choi_cham_soc: 'Bệnh nhân từ chối chăm sóc',
  bn_khong_nghe_may: 'Bệnh nhân không nghe máy quá 3 lần liên tiếp, mỗi lần cách nhau tối thiểu 6 tiếng',
  bn_khong_len_nc2_sau_10_ngay: 'NC0, 1 quá 10 ngày không lên NC2',
  bn_ra_vien_hon_10_ngay: 'Sau 10 ngày từ khi ra viện/khu cách ly',
  vuot_qua_kha_nang_bs: 'Vượt quá khả năng chuyên môn của Bác sĩ',
  da_ban_giao: 'Đã bàn giao cho y tế địa phương',
  khac: 'Khác'
});

const TYPE_TO_BADGE_CLASS_NAME = Object.freeze({
  care: 'badge badge-success',
  requestChangeNc: 'badge badge-dark',
  requestChangeNcAccept: 'badge badge-dark',
  requestChangeNcDeny: 'badge badge-dark',
  fault: 'badge badge-dark',
  removeFault: 'badge badge-dark',
  stopFollow: 'badge badge-secondary',
  stopFollowRequest: 'badge badge-secondary',
  stopFollowRequestApprove: 'badge badge-success',
  stopFollowRequestReject: 'badge badge-warning',
  reFollow: 'badge badge-success',
  requestEmergency: 'badge badge-warning',
  requestEmergencyCancel: 'badge badge-secondary',
  requestEmergencyApprove: 'badge badge-success',
  requestEmergencyReject: 'badge badge-danger',
  requestCommunityCare: 'badge badge-warning',
  requestCommunityCareCancel: 'badge badge-secondary',
  communityCare: 'badge badge-success',
  create: 'badge badge-info',
  update: 'badge badge-info',
});

export default {
  mixins: [list],
  components: {
    BenhNhanDetail,
    ButtonLinkUser,
  },
  props: {
    benhNhan: {
      type: Object,
      required: true,
      validator: benhNhan => !!benhNhan._id,
    },
  },
  data() {
    return {
      service: '/benh-nhan-call',
      autoLoad: true,
      defaultFilterFormModel: {
        benhNhan: this.benhNhan._id,
      },
    };
  },
  computed: {
    formattedEvents() {
      return this.items.map(event => {
        var note = event.note;

        if (event.type === 'stopFollow' || event.type === 'stopFollowRequest') {
          note = UNFOLLOW_TO_BADGE_TEXT[note || 'khac'];

          if (event.result) {
            note = note + ' : ' + event.result;
          }
        }

        return {
          ...event,
          note: note,
          displayedType: {
            text: TYPE_TO_BADGE_TEXT[event.type || 'care'],
            className: TYPE_TO_BADGE_CLASS_NAME[event.type || 'care'],
          },
        };
      });
    },
  },
};
</script>
